import { useFirebase } from './Firebase';
import { onAuthStateChanged, onValue } from '../helpers/Firebase/base';
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthenticationContext = createContext(null);

const useAuth = () => useContext(AuthenticationContext);

const AuthenticationProvider = ({ children }) => {
  const firebase = useFirebase();

  const [auth, setAuth] = useState({
    authenticating: true,
    name: null,
    role: null,
    user: null,
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebase.auth, authUser => {
      if (authUser) {
        const userRef = firebase.user(authUser.uid);
        onValue(userRef, (snapshot) => {
          const userData = snapshot.val();
          if (userData) {
            setAuth({
              authenticating: false,
              name: userData.name,
              user: authUser,
              role: userData.role,
            });
          }
        }, { onlyOnce: true });
      } else {
        setAuth({
          authenticating: false,
          user: null,
          role: null,
        });
      }
    });

    return () => unsubscribe();
  }, [firebase]);

  return (
    <AuthenticationContext.Provider value={ auth }>
      {children}
    </AuthenticationContext.Provider>
  )
};

export { AuthenticationContext, AuthenticationProvider, useAuth };